import Masonry from 'masonry-layout';

function initMasonry() {
    // make Masonry a jQuery plugin
    require('jquery-bridget')('masonry', Masonry, $);

    // now you can use $().masonry()
    $(".js-layout-masonry").masonry({
			itemSelector: ".c-masonry__item",
			percentPosition: true,
      columnWidth: ".c-masonry__sizer",
      gutter: 24
		})
}

initMasonry();